import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

// Pages
import GenderSelection from './pages/GenderSelection';
import Auth from './pages/Auth';
import Register from './pages/Register';
import MaleDashboard from './pages/MaleDashboard';
import FemaleDashboard from './pages/FemaleDashboard';
import Payments from './pages/Payments';
import WaitingApproval from './pages/WaitingApproval';
import VideoCall from './pages/VideoCall';
import AdminDashboard from './pages/AdminDashboard';
import EditProfile from './pages/EditProfile';

import './App.css';

// Protected Route Component
function ProtectedRoute({ children, requireApproval = false }) {
    const { user, loading } = useAuth();

    if (loading) {
        return <div className="loading">Loading...</div>;
    }

    if (!user) {
        return <Navigate to="/" />;
    }

    if (requireApproval && user.gender === 'female' && !user.isApproved) {
        return <Navigate to="/waiting" />;
    }

    return children;
}

function App() {
    return (
        <AuthProvider>
            <Router>
                <div className="App">
                    <Routes>
                        <Route path="/" element={<GenderSelection />} />
                        <Route path="/auth" element={<Auth />} />
                        <Route path="/register" element={<Register />} />
                        <Route 
                            path="/waiting" 
                            element={
                                <ProtectedRoute>
                                    <WaitingApproval />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/male-dashboard" 
                            element={
                                <ProtectedRoute requireApproval>
                                    <MaleDashboard />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/female-dashboard" 
                            element={
                                <ProtectedRoute requireApproval>
                                    <FemaleDashboard />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/payments" 
                            element={
                                <ProtectedRoute requireApproval>
                                    <Payments />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/video-call/:userId" 
                            element={
                                <ProtectedRoute requireApproval>
                                    <VideoCall />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/edit-profile" 
                            element={
                                <ProtectedRoute>
                                    <EditProfile />
                                </ProtectedRoute>
                            } 
                        />
                        <Route path="/admin" element={<AdminDashboard />} />
                    </Routes>
                </div>
            </Router>
        </AuthProvider>
    );
}

export default App;
